import { Auth0Provider } from "@auth0/auth0-react";
import { ReactNode } from "react";
import variables from "@/config/variables";

interface MultiAuth0ProviderProps {
  children: ReactNode;
  clientType: "consumer" | "banker";
}

export const MultiAuth0Provider = ({ children, clientType }: MultiAuth0ProviderProps) => {
  const getAuth0Config = () => {
    if (clientType === "consumer") {
      return {
        domain: variables.consumerAuth0Domain,
        clientId: variables.consumerAuth0ClientId,
        redirectUri: variables.consumerAuth0RedirectUri,
        audience: variables.consumerAuth0Audience,
        logoutUri: variables.consumerAuth0LogoutUri,
        orgId: variables.consumerAuth0OrgId,
      };
    } else {
      return {
        domain: variables.bankerAuth0Domain,
        clientId: variables.bankerAuth0ClientId,
        redirectUri: variables.bankerAuth0RedirectUri,
        audience: variables.bankerAuth0Audience,
        logoutUri: variables.bankerAuth0LogoutUri,
        orgId: variables.bankerAuth0OrgId,
      };
    }
  };

  const config = getAuth0Config();

  const authorizationParams: Record<string, any> = {
    redirect_uri: config.redirectUri,
    scope: "openid profile email",
  };

  // Add audience if provided
  if (config.audience) {
    authorizationParams.audience = config.audience;
  }

  // Add organization if provided
  if (config.orgId) {
    authorizationParams.organization = config.orgId;
  }

  return (
    <Auth0Provider
      domain={config.domain}
      clientId={config.clientId}
      onRedirectCallback={(appState) => {
        const returnTo = appState?.returnTo || window.location.origin;
        window.location.replace(returnTo);
      }}
      authorizationParams={authorizationParams}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
}; 